export const LANGUAGE_COOKIE_KEY = 'languageCookieKey'
export const SESSION_COOKIE_KEY = 'sessionCookieKey'
export const DELIVERY_TOKEN_HEADER_KEY = 'X-API-KEY'

export const AUTH_HEADER_TOKEN = 'Authorization'
export const SIGN_UP_MODE = 0
export const LOG_IN_MODE = 1
export const MALE = 'male'
export const FEMALE = 'female'
export const DAY_LESSON_CSV_URL = 'https://sifradigital-cms-jabrutouch.s3.amazonaws.com/cms3926896145652424982.csv'

//Getters
export const GET_UI_TEXT_BY_KEY = 'getUITextByKey'
export const GET_BODY_TEXT_BY_KEY = 'getBodyTextByKey'
export const GET_PROFILE_PHOTOS_LIST = 'loadDynamicProfilePhotos'
export const GET_SEARCH_PARAMS_CONTENT_TYPE_LESSON = 'getSearchParamsContentTypeLesson'
export const GET_SEARCH_PARAMS_CONTENT_TYPE_MASECHET = 'getSearchParamsContentTypeMasechet'
export const ARE_PARAMS_SEARCHABLE = 'areParamsSearchable'
export const GET_USER_FAVORITES = 'getUserFavorites'
export const GET_GOOGLE_PLATFORM_CLIENT_ID_URL = 'getGooglePlatformClientIdUrl'
export const GET_LOGGED_IN = 'getLoggedIn'

// export const GET_PRODUCT_BY_ID = 'getProductById'

//Mutations
export const CLEAR_PRESELECTED_DAF = 'clearPreselectedDaf'
export const SET_PRESELECTED_DAF = 'setPreselectedDaf'
export const INIT_ADDED_TO_CART_MODAL = 'initAddedToCartModal'
export const SET_SESSION = 'setSession'
export const SET_USER = 'setUser'
export const SET_USER_EVENTS = 'setUserEvents'
export const SET_USER_ATTRIBUTES = 'setUserAttributes'
export const SET_DAY_LESSON_MAP = 'setDayLessonCSV'
export const SET_TODAYS_LESSON = 'setTodaysLesson'
export const SET_SEDARIM = 'setSedarim'
export const SET_MASECHTOT = 'setMasechtot'
export const SET_TALMUD_PRODUCTS = 'setTalmudProducts'
export const SET_BOOK_PRODUCTS = 'setBookProducts'
export const ADD_PRODUCT_TO_CART = 'addProductToCart'
export const REMOVE_FROM_CART_BY_INDEX = 'removeFromCartByIndex'
export const UPDATE_PRODUCT_QUANTITY_BY_INDEX = 'updateProductQuantityByIndex'
export const UPDATE_PRODUCT_VARIANT_BY_INDEX = 'updateProductVariantByIndex'
export const SET_LANGUAGE = 'setLanguage'
export const SET_UI_TEXT = 'setUIText'
export const SET_BODY_TEXT = 'setBodyText'
export const LOAD_LANGUAGE_FROM_COOKIE = 'loadLanguageFromCookie'
export const LOAD_SESSION_FROM_COOKIE = 'loadSessionFromCookie'
export const SET_DYNAMIC_PROFILE_PHOTOS = 'setDynamicProfilePhotos'
export const SET_LESSON_VIDEO_CURRENT_TIME = 'setLessonVideoCurrentTime'
export const SET_LESSON_VIDEO_IS_PAUSED = 'setLessonVideoIsPaused'
export const SET_LESSON_TOTAL_PAGES = 'setLessonTotalPages'
export const SET_LESSON_PAGE_NUMBER = 'setLessonPageNumber'
export const SET_LESSON_PDF_LOADING_STATE = 'setLessonPdfLoadingState'
export const SET_SEARCH_TERM = 'setSearchTerm'
export const SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON = 'setSearchResultsContentTypeLesson'
export const SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET = 'setSearchResultsContentTypeMasechet'
export const SET_SEARCH_REQUEST_CANCELLATION_SOURCE = 'setSearchRequestCancellationSource'
export const SET_SIGNUP_SHOW_STATE = 'setSignupShowState'
export const SET_SIGNUP_MODE = 'setSignupMode'
export const SET_THANK_YOU_POPUP_SHOW_STATE = 'setThankYouPopupShowState'
export const SET_CONTACT_STATE = 'setContactState'
export const SET_GOOGLE_PLATFORM_STATE = 'setGooglePlatformState'
export const SET_GOOGLE_PLATFORM_AUTH_2_STATE = 'setGooglePlatformAuth2State'
export const SET_GOOGLE_LOGIN_STATE = 'setGoogleLoginState'
export const SET_FACEBOOK_SDK_STATE = 'setFacebookSdkState'
export const SET_FACEBOOK_LOGIN_STATE = 'setFacebookLoginState'


// Actions
export const PRE_INIT_STORE = 'preInitStore'
export const INIT_STORE = 'initStore'
export const LOAD_MASECHTOT = 'loadMasechtot'
export const LOAD_SEDARIM = 'loadSedarim'
export const LOAD_DAY_LESSON_MAP = 'loadDayLessonMap'
export const LOAD_TODAYS_LESSON = 'loadTodaysLesson'
export const LOAD_DYNAMIC_PROFILE_PHOTOS = 'loadDynamicProfilePhotos'
export const LOAD_TALMUD_PRODUCTS = 'loadTalmudProducts'
export const LOAD_BOOK_PRODUCTS = 'loadBookProducts'
export const LOAD_USER = 'loadUser'
export const UPDATE_USER = 'updateUser'
export const LOAD_USER_EVENTS = 'loadUserEvents'
export const LOAD_USER_ATTRIBUTES = 'loadUserAttributes'
export const ADD_USER_ATTRIBUTES = 'addUserAttributes'
export const ADD_USER_EVENT = 'addUserEvent'
export const REMOVE_USER_EVENT = 'removeUserEvent'
export const REMOVE_MANY_USER_EVENTS = 'removeManyUserEvents'
export const LOGOUT = 'logout'
export const SET_LANGUAGE_AND_RELOAD = 'setLanguageAndReload'
export const LOAD_UI_TEXT = 'loadUIText'
export const LOAD_BODY_TEXT = 'loadBodyText'
export const ADD_TO_CART = 'addToCart'
export const ADD_MULTIPLE_TO_CART = 'addMultipleToCart'
export const READ_AND_CLEAR_PRESELECTED_DAF = 'readAndClearPreselectedDaf'
export const SHOW_ADDED_TO_CART_MODAL = 'showAddedToCartModal'
export const LOAD_LESSON_PDF = 'loadLessonPdf'
export const NEXT_PDF_PAGE_IF_ABLE = 'nextPdfPageIfAble'
export const PREVIOUS_PDF_PAGE_IF_ABLE = 'previousPdfPageIfAble'
export const SEARCH = 'search'
export const SEARCH_LESSONS = 'searchLessons'
export const SEARCH_MASECHETS = 'searchMasechets'
export const CONTACT = 'contact'
export const INIT_GOOGLE_PLATFORM_AUTH_2 = 'initGooglePlatformAuth2'
export const ATTACH_GOOGLE_PLATFORM_AUTH_2_TO_ELEMENT = 'attachGooglePlatformAuth2ToElement'
export const LOGIN_WITH_GOOGLE = 'loginWithGoogle'
export const AUTHENTICATE_WITH_FACEBOOK = 'authenticateWithFacebook'
export const LOGIN_WITH_FACEBOOK = 'loginWithFacebook'
export const A_AFTER_NAVIGATION = 'actionAfterNavigation'
export const A_AFTER_NAVIGATION_LESSON_MODULE = 'actionAfterNavigationLessonModule'


// Loading States
export const LOADING_PRISTINE = 0
export const LOADING_STARTED = 1
export const LOADING_COMPLETED_SUCCESS = 2
export const LOADING_COMPLETED_FAILURE = 3

// Route names
export const ROUTE_ROOT = 'home'
export const ROUTE_STORE_SIDDER = 'storeSiddur'
export const ROUTE_STORE_TALMUD_ITEM = 'storeTalmudItem'
export const ROUTE_STORE_DIGITAL_ITEM = 'storeDigitalTalmud'
export const ROUTE_STORE_ROOT = 'storeRoot'
export const ROUTE_CART = 'cart'
export const ROUTE_ABOUT = 'about'
export const ROUTE_MISHNAYOT = 'mishnayot'
export const ROUTE_DEDICATION_DAY = 'dedicationDay'

// Event names
export const EVENT_SHOW_STATE = 'sfr-show-state'
export const EVENT_STEPPER_CHANGE = 'sfr-stepper-change'
export const EVENT_CLOSE_LESSON_FULLSCREEN = 'sfr-close-fullscreen'

// Component reference names
export const REF_BUTTON = 'jbrButtonRef'


// User Event action types
export const ACTION_FAVORITE = 'Favorite'
export const ACTION_HISTORY = 'History'

// Sponsorship reasons
export const ELOY_NISHMAS = 'לעילוי נשמת'
export const REFUAH_SHLAIMA = 'לרפואה שלמה'
export const ZIVUG_HAGOON = 'לזיווג הגון'
export const HATZLACHA = 'להצלחה'

// Dropdown modes
export const DEFAULT_MODE = 0
export const MASECHET_MODE = 1
export const DEDICATION_REASON_MODE = 2
export const DROPDOWN_CART_MODE = 3

// Stepper modes
export const STEPPER_DEFAULT_MODE = 0
export const STEPPER_CART_MODE = 1


// Item Categories
export const CATEGORY_DIGITAL_TALMUD = 0
export const CATEGORY_TALMUD = 1
export const CATEGORY_SIDDUR = 2

//Contact Component modes
export const CONTACT_COMPONENT_MODE_DEFAULT = 0
export const CONTACT_COMPONENT_MODE_DEDICATION_MASECHET = 1
export const CONTACT_COMPONENT_MODE_DEDICATION_YEAR = 2
export const CONTACT_COMPONENT_MODE_DEDICATION_DAY = 3

// Google Analytics
export const GA_UID = 'UA-132891522-1'





